import { render } from "./ErpCollectionsReport.vue?vue&type=template&id=30dc23d8&scoped=true"
import script from "./ErpCollectionsReport.vue?vue&type=script&lang=js"
export * from "./ErpCollectionsReport.vue?vue&type=script&lang=js"

import "./ErpCollectionsReport.vue?vue&type=style&index=0&id=30dc23d8&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30dc23d8"]])

export default __exports__